import React from 'react'

import { useTranslation } from 'react-i18next'

import AlertCard from '@components/myScores/MessagesView/AlertCard'
import AccountAlert from '@models/AccountAlert'
import { formatDate } from '@utils/formatters/date.formatter'

interface Props {
  alert: AccountAlert
}

const ExpiringCreditAccountAlert: React.FC<Props> = ({ alert }) => {
  const { t } = useTranslation()
  return (
    <AlertCard alert={alert}>
      <p className="text-lg mb-2.5">{t('content.expiringComp')}</p>
      <p>{t('content.expiringCompDetails', { date: formatDate(alert.date) })}</p>
    </AlertCard>
  )
}

export default ExpiringCreditAccountAlert
